import { NgModule } from '@angular/core';
import { AngularTawkComponent } from './angular-tawk.component';

@NgModule({
  declarations: [AngularTawkComponent],
  imports: [
  ],
  exports: [AngularTawkComponent]
})
export class AngularTawkModule { }
